import React, { useState } from "react";
import { Loader2, ShieldCheck, Eye, EyeOff } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { PasswordRules, isValidPassword } from "./ResetPassword";

export default function ForcePasswordChange() {
  const { setUser, logout, user } = useAuth();
  const [pwd, setPwd] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [showPwd, setShowPwd] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!isValidPassword(pwd)) { toast.error("Le mot de passe ne respecte pas les critères de sécurité."); return; }
    if (pwd !== confirm) { toast.error("Les deux mots de passe ne correspondent pas."); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/me/force-password", { new_password: pwd });
      setUser(data);
      toast.success("Mot de passe défini. Bienvenue !");
    } catch (err) { toast.error(err.response?.data?.detail || "Erreur"); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-8 beige-texture">
      <form onSubmit={submit} className="w-full max-w-sm bg-sable rounded-2xl border border-marine/10 shadow-md p-10" data-testid="force-password-card">
        <ShieldCheck size={16} className="text-bordeaux mb-3" />
        <div className="text-xs uppercase tracking-[0.25em] font-semibold text-bordeaux mb-2">Première connexion</div>
        <h1 className="font-display text-2xl text-marine mb-2">Définissez votre mot de passe</h1>
        <p className="text-sm text-marine/80 mb-6">Pour votre sécurité, veuillez choisir un mot de passe personnel avant d'accéder à votre espace.</p>
        <label className="block text-xs font-semibold uppercase tracking-wider text-marine/80 mb-1.5">Nouveau mot de passe</label>
        <div className="relative mb-3">
          <input data-testid="force-password" type={showPwd ? "text" : "password"} required value={pwd} onChange={(e) => setPwd(e.target.value)} className="inp pr-10" />
          <button type="button" onClick={() => setShowPwd((v) => !v)} data-testid="force-password-toggle"
            aria-label={showPwd ? "Masquer le mot de passe" : "Afficher le mot de passe"}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-marine hover:opacity-70">
            {showPwd ? <EyeOff size={16} /> : <Eye size={16} />}
          </button>
        </div>
        <PasswordRules value={pwd} />
        <label className="block text-xs font-semibold uppercase tracking-wider text-marine/80 mb-1.5">Confirmer</label>
        <div className="relative mb-6">
          <input data-testid="force-confirm" type={showConfirm ? "text" : "password"} required value={confirm} onChange={(e) => setConfirm(e.target.value)} className="inp pr-10" />
          <button type="button" onClick={() => setShowConfirm((v) => !v)} data-testid="force-confirm-toggle"
            aria-label={showConfirm ? "Masquer le mot de passe" : "Afficher le mot de passe"}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-marine hover:opacity-70">
            {showConfirm ? <EyeOff size={16} /> : <Eye size={16} />}
          </button>
        </div>
        <button data-testid="force-submit" disabled={busy} className="w-full bg-marine text-white rounded-xl py-3 text-sm font-semibold hover:bg-marine-hover transition-colors active:scale-95 flex items-center justify-center gap-2">
          {busy && <Loader2 size={16} className="animate-spin" />} Valider et continuer
        </button>
        <button type="button" onClick={logout} className="block mt-5 text-xs text-marine/80 hover:opacity-70 mx-auto">Se déconnecter ({user?.email})</button>
      </form>
    </div>
  );
}
